import React, { useState } from 'react';

import type { Fix } from '@/types/database/fix';

import AddFixModal from './components/AddFixModal';
import FixDetail from './components/FixDetail';
import FixList from './components/FixList';
import FixMessage from './components/FixMessages';
import FixProgress from './components/FixProgress';
import { FixFrontDeskWrapper } from './styles';

const FixFrontDesk: React.FC = () => {
  const [currentPage, setCurrentPage] = useState<
    'list' | 'add' | 'detail' | 'progress' | 'message'
  >('list');
  const [selectedFix, setSelectedFix] = useState<Fix | null>(null);

  return (
    <FixFrontDeskWrapper>
      {currentPage === 'list' && (
        <FixList
          addFix={() => setCurrentPage('add')}
          checkMore={(fix) => {
            setSelectedFix(fix);
            setCurrentPage('detail');
          }}
          checkMessage={(fix) => {
            setCurrentPage('message');
            setSelectedFix(fix);
          }}
          checkProgress={(fix) => {
            setCurrentPage('progress');
            setSelectedFix(fix);
          }}
          key={new Date().valueOf()}
        />
      )}
      {currentPage === 'add' && (
        <AddFixModal onClose={() => setCurrentPage('list')} />
      )}
      {currentPage === 'detail' && selectedFix && (
        <FixDetail
          selectedFix={selectedFix}
          onClose={() => setCurrentPage('list')}
        />
      )}
      {currentPage === 'message' && selectedFix && (
        <FixMessage
          selectedFix={selectedFix}
          onClose={() => setCurrentPage('list')}
        />
      )}
      {currentPage === 'progress' && selectedFix && (
        <FixProgress
          selectedFix={selectedFix}
          onClose={() => setCurrentPage('list')}
        />
      )}
    </FixFrontDeskWrapper>
  );
};

export default FixFrontDesk;
